import { render, staticRenderFns } from "./AnswersTable.vue?vue&type=template&id=22d918b5&scoped=true"
import script from "./AnswersTable.vue?vue&type=script&lang=ts"
export * from "./AnswersTable.vue?vue&type=script&lang=ts"
import style0 from "./AnswersTable.vue?vue&type=style&index=0&id=22d918b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d918b5",
  null
  
)

export default component.exports